import React from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import CusUploadImage from '../../../../../components/material-ui/CusUploadImage';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';

export default function CurrentBanner({
  banner,
  desktopFile,
  mobileFile,
  langCode,
  setBannerStruct
}) {
  const { t } = useTranslation();
  const { isMobile } = useBootstrapSize();

  const desktopId = banner.desktop.id;
  const mobileId = banner.mobile.id;
  const bannerId = banner.id;

  return (
    <Grid size={12}>
      <Card sx={{ height: '100%' }}>
        <Box gap={3} display={'flex'} flexDirection="column">
          <Typography fontWeight={600}>{t(banner.title)}</Typography>
          <Stack gap={2}>
            <CusUploadImage
              id={desktopId}
              title={banner.desktop.label}
              flexDirection={isMobile ? 'column' : 'row'}
              bannerNearby={!isMobile}
              Component={Box}
              imageSource={desktopFile?.base64Full || desktopFile}
              onChange={(base64Full, name) =>
                setBannerStruct((prev) => {
                  const base64 = base64Full.split('base64,')[1];
                  const prevInfo = JSON.parse(JSON.stringify(prev));
                  if (!prevInfo[langCode]) prevInfo[langCode] = {};
                  if (!prevInfo[langCode][bannerId]) prevInfo[langCode][bannerId] = {};

                  const fileInfo = { fileName: name, fileData: base64, base64Full };
                  const fileRes = base64 ? fileInfo : '';

                  prevInfo[langCode][bannerId].desktop = fileRes;
                  return prevInfo;
                })
              }
            />
            <CusUploadImage
              id={mobileId}
              title={banner.mobile.label}
              flexDirection={isMobile ? 'column' : 'row'}
              bannerNearby={!isMobile}
              imageSource={mobileFile?.base64Full || mobileFile}
              Component={Box}
              onChange={(base64Full, name) =>
                setBannerStruct((prev) => {
                  const base64 = base64Full.split('base64,')[1];
                  const prevInfo = JSON.parse(JSON.stringify(prev));
                  if (!prevInfo[langCode]) prevInfo[langCode] = {};
                  if (!prevInfo[langCode][bannerId]) prevInfo[langCode][bannerId] = {};
                  const fileInfo = { fileName: name, fileData: base64, base64Full };
                  const fileRes = base64 ? fileInfo : '';

                  prevInfo[langCode][bannerId].mobile = fileRes;
                  return prevInfo;
                })
              }
            />

            <ShowContainer condition={banner.footer}>
              <Typography variant="body2">{t(banner.footer)}</Typography>
            </ShowContainer>
          </Stack>
        </Box>
      </Card>
    </Grid>
  );
}
